import { Box, Typography } from '@mui/material';
import LegalLayout from './LegalLayout';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 5 }}>
    <Typography sx={{
      fontFamily: 'Frank Ruhl Libre, serif',
      fontWeight: 700,
      fontSize: '1.2rem',
      color: '#1e3a5f',
      mb: 1.5,
    }}>
      {title}
    </Typography>
    {children}
  </Box>
);

const P = ({ children }) => (
  <Typography sx={{
    fontFamily: 'Heebo, sans-serif',
    fontSize: '0.93rem',
    color: '#3a4a5a',
    lineHeight: 1.9,
    mb: 1.2,
  }}>
    {children}
  </Typography>
);

const TermsPage = () => (
  <LegalLayout title="תנאי שימוש" subtitle="עודכן לאחרונה: ינואר 2025">
    <Section title="1. קבלת התנאים">
      <P>
        ברוכים הבאים ל-inorai. השימוש בשירות מהווה הסכמה מלאה לתנאי שימוש אלה.
        אם אינכם מסכימים לתנאים — אנא הפסיקו את השימוש.
      </P>
      <P>
        "השירות" מתייחס לכלל הפלטפורמה של inorai, לרבות ממשק הניהול, מסכי התצוגה הציבוריים,
        הרכיבים, התבניות, ה-API ואתר האינטרנט.
      </P>
    </Section>

    <Section title="2. הרשמה וחשבון">
      <P>
        לצורך שימוש בשירות נדרשת הרשמה עם פרטים מדויקים. אתם אחראים לשמירה על סודיות
        סיסמת החשבון ולכל פעילות המתבצעת דרכו.
      </P>
      <P>
        כל ארגון רשאי לנהל מספר מסכים בהתאם למסלול שנבחר. אין להעביר חשבון לגורם אחר
        ללא אישור מראש בכתב.
      </P>
    </Section>

    <Section title="3. שימוש מותר">
      <P>
        השירות מיועד לניהול מסכי מידע ציבוריים במוסדות קהילתיים, בתי כנסת ואירגונים ללא מטרות רווח.
        מותר להשתמש בשירות לכל צורך חוקי ותקין.
      </P>
      <P>
        אסור לפרסם דרך השירות תוכן פוגעני, שיפוט שנאה, תוכן מטעה, פרסומות בלתי מורשות
        או כל תוכן המפר חוק ישראלי.
      </P>
    </Section>

    <Section title="4. תשלום וביטול">
      <P>
        תקופת הניסיון כוללת 14 יום ללא חיוב. לאחר מכן, ממשיכים למסלול בתשלום חודשי
        לפי הבחירה. לא מתבצע חיוב אוטומטי ללא אישור מפורש.
      </P>
      <P>
        ניתן לבטל מנוי בכל עת דרך הגדרות החשבון. הביטול ייכנס לתוקף בסוף תקופת החיוב הנוכחית.
        לא מוצעות החזרות כספיות יחסיות על תקופה שלא נוצלה, אלא במקרים חריגים ולפי שיקול דעתנו.
      </P>
    </Section>

    <Section title="5. קניין רוחני">
      <P>
        כל הקוד, העיצוב, התבניות, הלוגו והרכיבים של inorai הם רכוש החברה ומוגנים בזכויות יוצרים.
        התוכן שאתם יוצרים דרך השירות (טקסטים, לוגו ארגון, תמונות) נשאר בבעלותכם.
      </P>
    </Section>

    <Section title="6. אחריות ומגבלות">
      <P>
        השירות מסופק "כפי שהוא" (AS-IS). אנו שואפים לזמינות גבוהה אך אין אנו ערבים לזמינות
        רציפה של 100%. inorai לא תישא באחריות לנזקים עקיפים, אבדן רווחים או נזקי צד שלישי.
      </P>
      <P>
        גובה האחריות המרבית של inorai בכל מקרה לא תעלה על סכום התשלום ששולם בשלושת
        החודשים שקדמו לאירוע.
      </P>
    </Section>

    <Section title="7. שינויים בתנאים">
      <P>
        אנו רשאים לעדכן תנאים אלה מעת לעת. שינויים מהותיים יועברו בהודעה בדואר אלקטרוני
        לפחות 14 יום מראש. המשך השימוש לאחר השינוי מהווה הסכמה לתנאים המעודכנים.
      </P>
    </Section>

    <Section title="8. דין חל וסמכות שיפוט">
      <P>
        תנאי שימוש אלה כפופים לדין הישראלי. סמכות השיפוט הבלעדית תהיה לבתי המשפט המוסמכים
        בתל אביב–יפו.
      </P>
    </Section>

    <Section title="9. יצירת קשר">
      <P>
        לשאלות בנוגע לתנאי שימוש אלה, ניתן לפנות אלינו בכתובת:{' '}
        <Box
          component="a"
          href="mailto:ineraigroup@gmail.com"
          sx={{ color: '#9a7209', textDecoration: 'none', fontWeight: 600, '&:hover': { textDecoration: 'underline' } }}
        >
          ineraigroup@gmail.com
        </Box>
      </P>
    </Section>
  </LegalLayout>
);

export default TermsPage;
